import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import React from 'react';
import { Button, ButtonToolbar, Modal, Col, Card, Row, CardBody } from 'reactstrap';
import LoadingIcon from 'mdi-react/LoadingIcon';
import { uncheckAllSelectedCourses } from '../../redux/actions';
import api from '@/utils/apiClient';

export const CourseUpdateStatusDialog = ({ show, onHide }) => {
  const dispatch = useDispatch();
  const { rtl } = useSelector((state) => state, shallowEqual);
  const checkedCourseIds = useSelector(
    (state) => state.cadsAICourse.checkedCourseIds,
    shallowEqual,
  );
  const [status, setStatus] = React.useState({
    value: true,
    label: 'Activate',
  });
  const [modal, setModal] = React.useState({
    isOpen: show,
    message: 'Select Course status',
    hide: onHide,
    loading: false,
    updateStatusSuccess: false,
    updateStatusError: false,
  });

  const handleUpdateStatus = async () => {
    setModal({
      ...modal,
      loading: true,
      message: 'Course Status Update In Progress...',
    });
    const response = await api.cadsAICourse.deleteCourseState(checkedCourseIds, status.value);
    let updatedModal = {};
    if (response.isSuccess) {
      updatedModal = {
        loading: false,
        updateStatusSuccess: true,
        message: 'Course Updated Successfully!',
      };
      dispatch(uncheckAllSelectedCourses());
    } else {
      updatedModal = {
        loading: false,
        updateStatusError: true,
        message: 'Error Performing Course Status Update!',
      };
    }
    setModal({ ...modal, ...updatedModal });
  };

  return (
    <Modal
      isOpen={show}
      toggle={modal.hide}
      keyboard={false}
      backdrop={'static'}
      modalClassName={`${rtl.direction}-support`}
      className="modal-dialog--primary modal-dialog"
    >
      <div className="modal__header">
        {modal.updateStatusSuccess || <span className="lnr lnr-unlink modal__title-icon" />}
        {modal.updateStatusSuccess && (
          <span className="lnr lnr-thumbs-up modal__title-icon success" />
        )}
        <button
          className="lnr lnr-cross modal__close-btn"
          aria-label="modal__close-btn"
          type="button"
          onClick={modal.hide}
        />
        {modal.updateStatusSuccess && <h4 className="text-modal  modal__title">Done</h4>}
        {modal.updateStatusSuccess || (
          <h4 className="text-modal  modal__title">Deactivate Course</h4>
        )}
      </div>
      <div>
        <div className="ml-4">
          {modal.loading && (
            <div>
              <div className="panel__refresh position-relative" style={{ height: 75, width: 20 }}>
                <LoadingIcon />
                <div style={{ width: 200, padding: '23px 30px' }}>Updating status...</div>
              </div>
            </div>
          )}
          {(modal.updateStatusSuccess || !!modal.updateStatusError) && (
            <>
              <table className="mt-3 ml-4">
                <tr>
                  <td className="pl-2">
                    {modal.updateStatusSuccess ? 'Course Deactivated Successfully' : modal.message}
                  </td>
                </tr>
              </table>
            </>
          )}
        </div>
        <Row>
          <Col md={12} lg={12}>
            <Card className="pb-0">
              <CardBody>
                <div className="form-wrapper">
                  <div className="form">
                    <div className="form__form-group text-center">
                      {modal.updateStatusSuccess || (
                        <span className="form__form-group-label">
                          Are you sure you want to deactivate lcourse?
                        </span>
                      )}
                      <div className="form__form-group-field"></div>
                    </div>
                    <ButtonToolbar className="modal__footer btn-toolbar m-auto">
                      <>
                        {modal.updateStatusSuccess && (
                          <Button
                            color="secondary"
                            outline
                            className="text-center"
                            type="button"
                            onClick={() => modal.hide()}
                          >
                            Okay
                          </Button>
                        )}
                        {modal.updateStatusSuccess || (
                          <>
                            <Button
                              color="secondary"
                              type="button"
                              className="modal_cancel btn btn-secondary"
                              onClick={() => modal.hide()}
                            >
                              Cancel
                            </Button>
                            <Button
                              color="danger"
                              outline
                              type="submit"
                              onClick={handleUpdateStatus}
                            >
                              Yes, Deactivate
                            </Button>
                          </>
                        )}
                      </>
                    </ButtonToolbar>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};
